import { render, staticRenderFns } from "./TarfLayout.vue?vue&type=template&id=28bf7314&scoped=true"
import script from "./TarfLayout.vue?vue&type=script&lang=ts"
export * from "./TarfLayout.vue?vue&type=script&lang=ts"
import style0 from "./TarfLayout.vue?vue&type=style&index=0&id=28bf7314&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bf7314",
  null
  
)

export default component.exports